/**
 * 
 * @author Teresa Ocampo Román
 * @company Erillam Healthcare
 * @version 1.0
 * 
 */

import axios from 'axios';
import ServicePath from "@/core/ServicePath"
import {
    MainRequest
} from "@/core/request";

export default class UserRequest extends MainRequest {


    static addUser(data) {
        return this.postSEC(ServicePath.USER_ADD, data);
    }

    static listAllUsers(data) {
        return this.postSEC(ServicePath.USER_ALL, data);
    }

    static updateUser(data) {
        return this.postSEC(ServicePath.USER_UPDATE, data);
    }

    static deleteUser(data) {
        return this.postSEC(ServicePath.USER_DELETE, data);
    }

    static findUserById(data) {
        return this.postSEC(ServicePath.USER_FIND, data);
    }

    static restorePassword(data) {
        return this.postSEC(ServicePath.USER_RESTORE_PASSWORD, data);
    }

    static addSign(data) {
        return this.postSEC(ServicePath.SIGN_ADD, data);
    }

    static update(data) {
        return this.postSEC(ServicePath.USER_UPDATE_PROFILE, data);
    }

    static historyUser(data) {
        return this.postSEC(ServicePath.USER_HISTORY, data)
    }
    static listAllUsersByBranchOffice(data){
        return this.postSEC(ServicePath.USER_ALL_BRANCH_OFFICE, data)
    }
}